import store from '~/store/store'
import {AxiosResponse} from 'axios'

const redirect =async()=> {
  console.log('layout redirect')
  store.dispatch({type:'open-snack',payload:{alertType:'error',alertMessage:'session expired'}})

  setTimeout(()=>{
    store.dispatch({type:'open-snack-loading',payload:{alertMessage:'redirecting...'}})
  },3000)

  setTimeout(()=>{
    store.dispatch({type:'close snack bar'})
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    store.dispatch({type:'logged out',payload:""})
    window.location.href='/login'
  },5000)
}

export const responseIntercept = async(response:AxiosResponse)=>{
  let expiredTok = response.data.error
  if (expiredTok) redirect();
  return response

}

export const errorIntercept = async(error:any)=>{
  if(error.message==='Network Error' && !error.response){
    console.log('Network Error');
    // window.location.href='/login'
    store.dispatch({type:'open-snack',payload:{alertType:'warning',alertMessage:'Network Error'}})
  }
  const {status} = error.response
  console.log('Intercept user',error);
  if(status ===401) redirect();
  if(status ===404) redirect();
  if(status ===400) redirect();
  if(status ===429) {
    store.dispatch({type:'open-snack',payload:{alertType:'error',alertMessage:'too many attempt'}})
    
  }

}